import { haversineDistance } from '@/shared/lib/distance';
import { getSafeCoords, MaybeLatLon } from '@/shared/lib/geo';
import { CompleteVenue } from '../types/CompleteVenue';

/**
 * Returns venues ordered by their distance from an address.
 * Venues or addresses without valid coordinates are placed last.
 */
export const getSortedVenuesByDistance = (venues: CompleteVenue[], address: MaybeLatLon) => {
    return venues
        .map((venue) => {
            const latLon = getSafeCoords(venue.address);
            const addressLatLon = getSafeCoords(address);
            return {
                ...venue,
                distance: latLon && addressLatLon ? haversineDistance(addressLatLon, latLon) : Infinity,
            };
        })
        .sort((a, b) => a.distance - b.distance);
};
